import { CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BackToHubert = () => {
  const { t } = useTranslation();
  return (
    <div className="absolute right-8 top-2.5">
      <a href="https://hubert.ai" className="text-gray-900 flex flex-row items-center">
        <span className="align-middle">{t('nav.backToHubert.label')}</span>
        <CircleX className="mx-2" size={32} />
      </a>
    </div>
  );
};

export default BackToHubert;
